import { render, staticRenderFns } from "./AvacadoTreeDetail.vue?vue&type=template&id=1222f4f6&scoped=true"
import script from "./AvacadoTreeDetail.vue?vue&type=script&lang=js"
export * from "./AvacadoTreeDetail.vue?vue&type=script&lang=js"
import style0 from "./AvacadoTreeDetail.vue?vue&type=style&index=0&id=1222f4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222f4f6",
  null
  
)

export default component.exports